// Mock data for Nacodara website

export const heroData = {
  logo: "Nacodara",
  mainHeading: "Fabricamos produtos para",
  subHeading: "Entusiastas da Programação",
  tagline: "Na Nacodara, buscamos a perfeição em nosso trabalho.",
  ctaText: "Explore nossos produtos"
};

export const nacodaraSection = {
  brandName: "Nacodarsssa",
  heading: "Recurso de qualidade para programadores",
  stats: "A Nacodara é uma plataforma moçambicana de aprendizagem digital que ajuda jovens de todo o país a desenvolver habilidades em programação e tecnologia. Oferecemos cursos acessíveis, simples de entender e ligados à realidade do nosso mercado. Aqui, aprender não é complicado — é passo a passo, no teu ritmo, e com apoio. Acreditamos no poder da juventude moçambicana para criar, inovar e transformar o futuro.",
  ctaButton: "Saber mais"
};

export const learningCard = {
  title: "Aprenda programação",
  subtitle: "grátis",
  description: "Aprenda a programar com nossos tutoriais e exemplos para iniciantes. Leia os tutoriais, experimente os exemplos, escreva código e aprenda a programar.",
  emailPlaceholder: "Insira seu endereço de e-mail",
  subscribeButton: "Inscreva-se",
  formHeading: "Acesse os tutoriais e atualizações mais recentes."
};

export const languages = [
  {
    id: 1,
    name: "PYTHON",
    subtitle: "PROGRAMAÇÃO",
    icon: "Py",
    color: "#3776AB"
  },
  {
    id: 2,
    name: "C",
    subtitle: "PROGRAMAÇÃO",
    icon: "C",
    color: "#A8B9CC"
  },
  {
    id: 3,
    name: "C++",
    subtitle: "PROGRAMAÇÃO",
    icon: "C++",
    color: "#00599C"
  },
  {
    id: 4,
    name: "JAVA",
    subtitle: "PROGRAMAÇÃO",
    icon: "☕",
    color: "#007396"
  }
];

export const languageSection = {
  heading: "Escolha o que aprender",
  subheading: "Comece a aprender as melhores linguagens de programação."
};

export const mobileAppSection = {
  badge: "APRENDA PYTHON",
  heading: "Nosso aplicativo Python para dispositivos móveis: iOS e Android",
  description: "Nosso aplicativo foi desenvolvido com a colaboração da comunidade.",
  subtext: "Aprenda a programar em Python com nosso aplicativo interativo. Disponível para iOS e Android.",
  downloadButtons: [
    { type: "ios", text: "Baixe na App Store" },
    { type: "android", text: "Baixe no Google Play" }
  ]
};
